import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import CartDrawer from "./CartDrawer";
import CampaignLayer from "./CampaignLayer";
import StoreSignals from "./StoreSignals";
import StoreTheme from "./StoreTheme";

export default function StoreLayout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <div className="store flex flex-col" data-testid="storefront">
      <Header />
      <StoreTheme />
      <StoreSignals />
      <CampaignLayer />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <CartDrawer />
    </div>
  );
}
